import { getEpsImagePartsFromUrl } from './getEpsImagePartsFromUrl';
import { getEpsImageUrlFromParts } from './getEpsImageUrlFromParts';
export const getEpsImageUrl = (url, { size, format, protocol }) => {
    const parts = getEpsImagePartsFromUrl(url.href);
    return getEpsImageUrlFromParts({
        protocol: parts.protocol || (protocol && `${protocol}://`) || '//',
        baseUrl: parts.baseUrl,
        zoomId: parts.zoomId,
        size: size || parts.size,
        suffix: parts.suffix || format,
        queryString: parts.queryString
    });
};
